import { NormalizedDropdownItemType } from '@entur/dropdown';
import { VariantType } from '@entur/form';
import { useIntl } from 'react-intl';
import Dropdown from '../Dropdown';

interface StatusDropdownProps {
  variant?: VariantType;
  feedback?: string;
  onChangeStatus: (item: NormalizedDropdownItemType | null) => void;
  placeholder?: string;
  className?: string;
  readonly?: boolean;
  isCreateMode?: boolean;
  selectedItem?: string;
  required?: boolean;
}

const StatusDropdown = ({
  variant,
  feedback,
  onChangeStatus,
  placeholder,
  className,
  readonly = false,
  isCreateMode = false,
  selectedItem,
  ...rest
}: StatusDropdownProps) => {
  const intl = useIntl();

  const getStatusDropdownItems = () => {
    const items = [
      {
        label: intl.formatMessage({ id: 'generalValues.statusActive' }),
        value: '1',
      },
      {
        label: intl.formatMessage({ id: 'generalValues.statusPaused' }),
        value: '2',
      },
      {
        label: intl.formatMessage({ id: 'generalValues.statusDiscontinued' }),
        value: '3',
      },
    ];

    if (isCreateMode) {
      return items.filter((item) => item.value !== '3');
    }

    return items;
  };

  const statusItems = getStatusDropdownItems();

  return (
    <Dropdown
      {...rest}
      variant={variant}
      feedback={feedback}
      label={intl.formatMessage({ id: 'generalValues.status' })}
      items={statusItems}
      selectedItem={statusItems.find((item) => item.value === selectedItem) ?? null}
      placeholder={placeholder}
      className={className}
      readOnly={readonly}
      onChange={onChangeStatus}
    />
  );
};

export default StatusDropdown;
